import React from 'react';
import classNames from 'classnames';

import './award.scss';

const Award = ({
	index,
	award,
	totalItems,
}) => (
	<div
		className={classNames(
			'card',
			{ first: index === 0 },
			{ last: index === 	totalItems - 1 },
		)}
		key={index}
	>
		{award.image && (
			<div className="image-section">
				<div
					className="image"
					style={{ backgroundImage: `url('${process.env.REACT_APP_API_ENDPOINT + award.image.path}')` }}
				/>
			</div>
		)}
	</div>
);


export default Award;
